import styled from 'styled-components';
import { Select } from 'antd';

export const HeaderTable = styled.div`
  display: flex;
  height: 40px;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
  background: white;
  border-radius: 6px;
  padding: 20px;
`;

export const TitleScreen = styled.h2`
  font-family: 'inter-semibold', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: var(--FORM-LABEL-default);
  //padding: 10px;
  ${(props) => props?.shortenTitle && 'text-overflow: ellipsis;'}
  ${(props) => props?.shortenTitle && 'white-space: nowrap;'}
    ${(props) => props?.shortenTitle && 'overflow: hidden;'}
    ${(props) => props?.shortenTitle && 'width: 69%;'}
`;

export const GroupButton = styled.div`
  display: flex;
  align-items: center;

  gap: 14px;

  @media all and (min-width: 0px) and (max-width: 320px) {
    flex-wrap: wrap;
  }
  @media all and (min-width: 320px) and (max-width: 430px) {
    flex-wrap: wrap;
  }

  .ant-input {
    height: 36px;
    font-size: 14px;

    &::placeholder {
      font-size: 14px;
    }
  }

  .ant-btn {
    height: 36px;
  }
`;

export const SelectPageStyled = styled(Select)`
  width: 120px;
  min-width: 120px;
  height: 36px;
  flex-grow: 1;

  span {
    font-family: 'inter-regular', sans-serif;
    font-weight: 500;
    color: var(--FORM-LABEL-default);
  }
`;

export const FormDropDownGroup = styled.div`
  display: grid;
  grid-template-columns: 100px 300px;
  column-gap: 15px;
  color: #656464;
  font-size: 16px;

  .ant-form-item {
      margin-bottom: 0;
  }
`;

export const Grid1 = styled.div`
  grid-column: 1 / 2;
  display: flex;
  align-items: center;
`;

export const Grid2 = styled.div`
  grid-column: 2 / 3;
`;

export const TitleStyled = styled.div`
  font-size: 14px;
  font-family: 'inter-regular', sans-serif;
`;